// Payment iframes keep growing the next step for a few seconds after it renders.
const ANCHOR_PAUSE_MS = 5000

let anchorTimer: ReturnType<typeof setTimeout> | undefined
let savedAnchor: string | null = null

// Pause host-page scroll anchoring, which otherwise follows the clicked button down as the step grows.
function pauseScrollAnchoring () {
  const root = (document.scrollingElement || document.documentElement) as HTMLElement
  if (savedAnchor === null) savedAnchor = root.style.overflowAnchor
  root.style.overflowAnchor = 'none'
  clearTimeout(anchorTimer)
  anchorTimer = setTimeout(() => {
    root.style.overflowAnchor = savedAnchor ?? ''
    savedAnchor = null
  }, ANCHOR_PAUSE_MS)
}

// Multi-step forms swap steps in place; bring the steps bar back into view when it's above the viewport.
export function scrollToStepsBar (bar: HTMLElement | null) {
  if (!bar) return
  const offset = parseFloat(getComputedStyle(bar).scrollMarginTop) || 0
  if (bar.getBoundingClientRect().top >= offset) return
  pauseScrollAnchoring()
  bar.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
